export default __webpack_public_path__ + "static/media/tree-mammoth-crop.0d682302.jpg";